import {MouseEvent} from "react";

export default function stopPropagate(e : MouseEvent) : void {
    e.stopPropagation()
    e.preventDefault()
}
